import { fetchFromUrlPOSTAsync, fetchFromUrlGETAsync, fetchFromUrlPATCHAsync, fetchFromUrlDELETEAsync } from '../fetch'

const routeBase = 'referral-codes'

export const actions = {
  getList: async ({ page, perPage, order, orderBy, searchField, searchKeyword }) => {
    try {
      const urlParams = new URLSearchParams('')
      urlParams.append('page', page)
      urlParams.append('perPage', perPage)
      urlParams.append('order', order)
      urlParams.append('orderBy', orderBy)
      if (searchField && searchKeyword) {
        urlParams.append('searchField', searchField)
        urlParams.append('searchKeyword', searchKeyword)
      }

      const result = await fetchFromUrlGETAsync(`/${routeBase}/?${urlParams}`)

      return result || {}
    } catch (e) {
      console.error(e.message)
      return {}
    }
  },

  getReferralCodeUsersList: async (referralCodeId, { page, perPage }) => {
    try {
      const urlParams = new URLSearchParams('')
      urlParams.append('page', page)
      urlParams.append('perPage', perPage)

      const result = await fetchFromUrlGETAsync(`/${routeBase}/${referralCodeId}/users/?${urlParams}`)

      return result || {}
    } catch (e) {
      console.error(e.message)
      return {}
    }
  },

  getById: async id => {
    try {
      const result = await fetchFromUrlGETAsync(`/${routeBase}/${id}`)

      return result || {}
    } catch (e) {
      console.error(e.message)
      return {}
    }
  },

  save: async saveData => {
    try {
      let result = {}
      const { _id } = saveData
      if (_id) {
        result = await fetchFromUrlPATCHAsync(`/${routeBase}/${_id}`, [], saveData)
      } else {
        result = await fetchFromUrlPOSTAsync(`/${routeBase}`, [], saveData)
      }

      return result || {}
    } catch (e) {
      console.error(e.message)
      return {}
    }
  },

  deleteById: async id => {
    try {
      const result = await fetchFromUrlDELETEAsync(`/${routeBase}/${id}`)

      return result || {}
    } catch (e) {
      console.error(e.message)
      return {}
    }
  }
}
